import { DEFAULT_UI_LANGUAGE, normalizeUiLanguage } from '../i18n/language';

export type LegalPageSlug = 'cgv' | 'privacy' | 'mentions-legales';

const MARKETING_ORIGIN =
  (import.meta.env.VITE_MARKETING_ORIGIN as string) || 'https://themusic.school';

const LEGAL_PATHS: Record<LegalPageSlug, string> = {
  cgv: 'terms-of-service.html',
  privacy: 'privacy-policy.html',
  'mentions-legales': 'conditions.html',
};

export function getLegalUrl(page: LegalPageSlug, lang?: string | null): string {
  const code = normalizeUiLanguage(lang || DEFAULT_UI_LANGUAGE);
  return `${MARKETING_ORIGIN}/${code}/${LEGAL_PATHS[page]}`;
}

export function getLegalUrlWithReturn(
  page: LegalPageSlug,
  lang?: string | null,
  _returnTo?: string,
): string {
  return getLegalUrl(page, lang);
}
